export default {
  path: '/service/:code',
  name: 'r_service',
  meta: {},
  component: () => import('../../components/services/AnonymousServices'),
};
